export const translations = {
  en: require("./en.json"),
  fr: require("./fr.json"),
};
